import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const navLinks = [
    { href: '#criteria', label: 'Criteria' },
    { href: '#about', label: 'About' },
    { href: '#process', label: 'Process' },
    { href: '#expectations', label: 'Expectations' },
    { href: '#faq', label: 'FAQ' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <footer className="bg-gradient-to-b from-[#0a1929] to-[#071321]" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-6 pt-16 pb-8">
        
        {/* Top Section - Brand & CTA */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 pb-12 mb-12 border-b border-white/10">
          <div>
            <h3 className="text-2xl font-bold text-white mb-2">Crestfield Services</h3>
            <p className="text-white/50 text-sm">Long-term acquisition of UK mechanical services businesses.</p>
          </div>
          <a 
            href="#contact"
            onClick={(e) => scrollToSection(e, '#contact')}
            className="inline-flex items-center gap-2 bg-white text-[#0a1929] px-6 py-3 rounded-lg font-semibold text-sm hover:bg-white/90 transition-all w-fit"
          >
            Start a Conversation
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        {/* Middle Section - Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 pb-12 mb-8 border-b border-white/10">
          
          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5">Contact</h4>
            <a 
              href="mailto:hello@crestfieldservices.co.uk" 
              className="flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors group"
            >
              <Mail className="w-4 h-4 text-white/40 group-hover:text-white transition-colors" />
              hello@crestfieldservices.co.uk
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5">Navigation</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a 
                    href={link.href} 
                    onClick={(e) => scrollToSection(e, link.href)} 
                    className="text-white/60 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-white/60 hover:text-white text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-white/60 hover:text-white text-sm transition-colors">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-white/60 hover:text-white text-sm transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Principal */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5">Principal</h4>
            <p className="text-white font-medium mb-1">Amogh Achalkar</p>
            <p className="text-white/50 text-sm mb-4">Founder & Principal</p>
            <a 
              href="https://www.linkedin.com/in/amogh-achalkar-4b505721a"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors group"
            >
              <Linkedin className="w-4 h-4" />
              View LinkedIn
              <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} Crestfield Services Ltd.
          </p>
          <p className="text-white/30 text-sm">
            Registered in England and Wales
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
